define("settings/components/section/item-details", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tAC--section__detail" ...attributes>
    {{#if (has-block "title")}}
      {{yield to="title"}}
    {{else if @title}}
      <span class={{@titleStyles}}>
        {{@title}}
      </span>
    {{/if}}
  
    {{#if @description}}
      <p class={{@descriptionStyles}}>{{@description}}</p>
    {{/if}}
  
    {{yield}}
  </div>
  */
  {
    "id": "+tLFEOev",
    "block": "[[[11,0],[24,0,\"tAC--section__detail\"],[17,1],[12],[1,\"\\n\"],[41,[48,[30,6]],[[[1,\"    \"],[18,6,null],[1,\"\\n\"]],[]],[[[41,[30,2],[[[1,\"    \"],[10,1],[15,0,[30,3]],[12],[1,\"\\n      \"],[1,[30,2]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],null]],[]]],[1,\"\\n\"],[41,[30,4],[[[1,\"    \"],[10,2],[15,0,[30,5]],[12],[1,[30,4]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[18,7,null],[1,\"\\n\"],[13]],[\"&attrs\",\"@title\",\"@titleStyles\",\"@description\",\"@descriptionStyles\",\"&title\",\"&default\"],false,[\"if\",\"has-block\",\"yield\"]]",
    "moduleName": "settings/components/section/item-details.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});